export default __webpack_public_path__ + "static/media/CSLogo4.f229728a.png";